import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Common, i18nService } from '@meplis/services';
import { MatMenuModule } from '@angular/material/menu';
import { ProfileAvatarComponent } from '../profile-avatar/profile-avatar.component';
import { MenuItem } from '../../../models/menu/menu-item';
import { LanguagesFilter, ProfileEntity } from '@meplis/common';
import { ProfileService } from '../../../services/application/profile.service';
import { ProfileWidgetComponent } from '../profile-widget/profile-widget.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ProfileAvatarComponent,
    MatMenuModule,
    ProfileWidgetComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  public logoUrl: string = 'images/care-monitor-logo.svg';
  public avatarUrl: string = 'images/avatar.png';

  public profileBackgroundImageUrl: string = 'images/profile-background.png';
  public mobileMenuOpened: boolean;
  public mobileSearchOpened: boolean;
  public searchFilter: string;

  public currentRoute: string;
  public socialInstanceId: string;

  public menuItems: MenuItem[] = [];
  public profile: ProfileEntity;

  public languages = LanguagesFilter;

  public subscription: Subscription;
  public routerSubscription: Subscription;

  constructor(
    public commonService: Common,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _profileService: ProfileService,
    private _i18nService: i18nService
  ) {
    this.routerSubscription = this._activatedRoute.url.subscribe((segments) => {
      this.currentRoute = segments.map((segment) => segment.path).join('/');
    });
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscription = this._profileService.getProfile().subscribe((profile) => {
      this.profile = profile;
    });
  }

  public changeLanguage(languageCode: string): void {
    this._i18nService.setLocale(languageCode, 'meplis-ngage');
  }

  public toogleSearchMobile(): void {
    this.mobileSearchOpened = !this.mobileSearchOpened;
  }

  public toogleMobileMenu(): void {
    this.mobileMenuOpened = !this.mobileMenuOpened;
  }

  public selectMenu(menu: MenuItem): void {
    this.menuItems.forEach((menu) => (menu.selected = false));
    menu.selected = true;
    this.goToRoute(menu.route);
  }

  public goToRoute(route: string): void {
    this._router.navigate([route]);
  }
}
